import React from 'react';

// Renders a single NavTile with an image and label.
const NavTile = ({ tile }) => {
  return (
    <a className="tile" href={tile.linkURL || '#'}>
      <div className="tile-image-container">
        <img 
          alt={tile.description} 
          className="tile-image" 
          src={tile.imageURL} 
        />
      </div>
      <div className="tile-label">
        <div className="tile-link">
          {tile.label}
        </div>
      </div>
    </a>
  );
};

export default NavTile;